import { Col, Row } from 'antd';
import styled from 'styled-components';

export const NotificationOuterContainerStyled = styled(Row)`
  padding: 14px;
  &:hover {
    background-color: #e9e5de;
    cursor: pointer;
  }
  &.dark {
    &:hover {
      background-color: #323a43;
    }
  }
  &.dark {
    &:hover {
      background-color: #323a43;
    }
  }
  flex-wrap: nowrap;
  margin: 0;
`;

export const NotificationContentContainerStyled = styled(Row)`
  margin: 0;
  flex-wrap: nowrap;
`;

export const NotificationIconContainerStyled = styled(Col)`
  padding-top: 5px;
`;

export const NotificationListStyled = styled.ul`
  list-style: none;
  padding: 0;
`;
